import store from '../data/store';
import { IColor } from '../interfaces';
import { IFormState } from '../data/slices/form-slice';
import { IRootState } from '../data/slices/root-slice';
import { IconBackgroundType } from '../enums/IconBackgroundType';

const serializeColor = (color: IColor) => {
  return `${ color.r }-${ color.g }-${ color.b }-${ color.a }`;
};

const deserializeColor = (colorStr: string) => {
  const parts = colorStr.split('-');

  if(parts.length !== 4) {
      return {
          r: 0,
          g: 0,
          b: 0,
          a: 1,
      };
  }

  return {
      r: Number(parts[0]) || 0,
      g: Number(parts[1]) || 0,
      b: Number(parts[2]) || 0,
      a: Number(parts[3]) || 1,
  }
};

export const generateDeepLink = () => {

    const state = store.getState();
    if(!state || !state.root || !state.root.randomIcon || !state.form) return '';

    const randomIcon = state.root.randomIcon;
    const iconKey = randomIcon.iconKey;
    const category = state.root.category;
    const strokeWidth = state.form.strokeWidth;
    const strokeColor = state.form.strokeColor;
    const hasStroke = state.form.hasStroke;
    const fillColor = state.form.fillColor;
    const hasFill = state.form.hasFill;
    const backgroundColor = state.form.backgroundColor;
    const backgroundType = state.form.backgroundType;
    const rotation = state.form.rotation;
    const scale = state.form.scale;
    const sharpness = state.form.sharpness;
    const smoothness = state.form.smoothness;

    const parts = [
        {
            key: 'icon',
            value: iconKey,
        },
        {
            key: 'category',
            value: category,
        },
        {
            key: 'stroke-width',
            value: strokeWidth.toFixed(2),
        },
        {
            key: 'stroke-color',
            value: serializeColor(strokeColor),
        },
        {
            key: 'has-stroke',
            value: hasStroke,
        },
        {
            key: 'fill-color',
            value: serializeColor(fillColor),
        },
        {
            key: 'has-fill',
            value: hasFill,
        },
        {
            key: 'bg-color',
            value: serializeColor(backgroundColor),
        },
        {
            key: 'bg-type',
            value: backgroundType,
        },
        {
            key: 'rotation',
            value: rotation.toFixed(2),
        },
        {
            key: 'scale',
            value: scale.toFixed(2),
        },
        {
            key: 'sharpness',
            value: sharpness.toFixed(2),
        },
        {
            key: 'smoothness',
            value: smoothness.toFixed(2),
        },
    ];

    const qs = parts.map(item => `${ encodeURIComponent(item.key) }=${ encodeURIComponent(item.value) }`).join('&');
    const url = new URL(window.location.href);
    url.search = qs;

    window.history.replaceState({},'', url.toString());
};

export const restoreIconDropDeepLink = () => {
    const url = new URL(window.location.href);
    if(!url.search) return null;
    return url.searchParams.get('icon');
};

export const restoreFromDeepLink = (formData: IFormState|null, stateData: IRootState|null) => {
    const url = new URL(window.location.href);
    if(!url.search) return;

    url.searchParams.forEach((value, key) => {

        switch(key){
            case 'icon': {
                if(stateData){
                    /*
                    const icon = await getIconByKey(getIconsData(), value);
                    if(icon){
                        stateData.randomIcon = icon;
                    }*/
                }
                break;
            }
            case 'category': {
                if(stateData){
                    stateData.category = value;
                }
                break;
            }
            case 'stroke-width': {
                if(formData){
                    formData.strokeWidth = Number(value) || 1;
                }
                break;
            }
            case 'stroke-color': {
                if(formData){
                    formData.strokeColor = deserializeColor(value);
                }
                break;
            }
            case 'has-stroke': {
                if(formData){
                    formData.hasStroke = value === 'true';
                }
                break;
            }
            case 'fill-color': {
                if(formData){
                    formData.fillColor = deserializeColor(value);
                }
                break;
            }
            case 'has-fill': {
                if(formData){
                    formData.hasFill = value === 'true';
                }
                break;
            }
            case 'bg-color': {
                if(formData){
                    formData.backgroundColor = deserializeColor(value);
                }
                break;
            }
            case 'bg-type': {
                if(formData){
                    formData.backgroundType = Number(value) || IconBackgroundType.Transparent;
                }
                break;
            }
            case 'rotation': {
                if(formData){
                    formData.rotation = Number(value) || 0;
                }
                break;
            }
            case 'scale': {
                if(formData){
                    formData.scale = Number(value) || 0.8;
                }
                break;
            }
            case 'sharpness': {
                if(formData){
                    formData.sharpness = Number(value) || 0;
                }
                break;
            }
            case 'smoothness': {
                if(formData){
                    formData.smoothness = Number(value) || 0;
                }
                break;
            }
        }
    });
};